import CreateEditPushNotification from "@/app/app-shared/push-notification/create-edit";

export default function CreateEditPushNotificationPage() {
  return <CreateEditPushNotification />;
}
